<template>
    <div
        ref="filter"
        class="filter"
        :class="{ 'show--filters': showAllFilters }"
    >
        <form>
            <div
                v-for="option in orderedfilters"
                :key="option.id"
                class="form-group form-group--checkbox mb-0"
            >
                <div
                    v-if="option.filterName == 'lessonType'"
                    class="control-label row"
                >
                    <h3 class="color--purple-2 col-4 col-md-11">
                        snel zoeken op:
                    </h3>
                    <v-selector
                        :id="option.id"
                        v-model="filters[option.filterName]"
                        :options="option.filters"
                        label="label"
                        :reduce="(option => option.name, option.filter)"
                        :multiple="option.isMultiSelect"
                        class="col-8 col-md-11 mb-4"
                    >
                        <template #selected-option="{ name }">
                            {{ name }}
                        </template>
                        <span slot="no-options">Geen resultaten gevonden</span>
                    </v-selector>
                    <hr />
                </div>
                <div v-else>
                    <label for="type" class="control-label row">
                        <span class="col-4 col-md-12 pb-0">{{
                            option.name
                        }}</span>
                        <v-selector
                            :id="option.id"
                            v-model="filters[option.filterName]"
                            :options="option.filters"
                            label="label"
                            :reduce="(option => option.name, option.filter)"
                            :multiple="option.isMultiSelect"
                            class="col-8 col-md-12 pt-1"
                        >
                            <template #selected-option="{ name }">
                                {{ name }}
                            </template>
                            <span slot="no-options"
                                >Geen resultaten gevonden</span
                            >
                        </v-selector>
                    </label>
                </div>
            </div>
        </form>
        <div class="filter__show-more">
            <button
                type="button"
                class="btn btn--medium btn--purple-2 color--white"
                @click="toggleShowAllFilters()"
            >
                <span v-if="!showAllFilters"
                    >{{ buttonText }} <i class="fas fa-plus ml-1"></i
                ></span>
                <span v-else
                    >Toon minder filters <i class="fas fa-minus ml-1"></i
                ></span>
            </button>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        titleFilters: {
            type: String,
            default: ''
        },
        buttonText: {
            type: String,
            default: ''
        },
        options: {
            type: Object,
            default() {
                return {};
            }
        },
        filters: {
            type: Object,
            default() {
                return {};
            }
        },
        value: {
            type: Array,
            default() {
                return [];
            }
        },
        extraFilters: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedFilters: [],
            showAllFilters: false
        };
    },
    computed: {
        orderedfilters: function() {
            return _.orderBy(this.options, 'id');
        }
    },
    watch: {
        selectedFilters(val) {
            this.$emit('input', val);
        }
    },

    methods: {
        toggleShowAllFilters() {
            this.showAllFilters = !this.showAllFilters;
            this.$refs.filter.scrollTop = 0;
        }
    }
};
</script>

<style lang="scss">
.filter {
    padding: 110px 0 100px 0;
    overflow: hidden;
    position: relative;
    height: calc(100vh - 130px);
    transition: 0.5s height ease-in-out;

    &.show--filters {
        height: 100%;
        overflow-y: auto;
        z-index: 2;
    }

    @include media-breakpoint-up(lg) {
        padding: 110px 0 150px;
    }

    @include media-breakpoint-up(xl) {
        padding: 80px 0 150px 20px;
    }

    @media (min-width: 1920px) {
        padding: 80px 0 150px 50px;
    }

    @media (min-width: 2560px) {
        padding: 80px 0 150px 40px;
    }
}

.filter label {
    color: $purple-2;
    width: 100%;
}

.filter h2 {
    font-size: 1.5rem;
}

.filter__show-more {
    background-color: rgba($white, 0.85);
    position: absolute;
    left: 0;
    bottom: 0;
    width: 90%;
    padding: 20px 0;
    text-align: center;
    z-index: 5;

    .show--filters & {
        position: relative;
    }

    @media (min-width: 768px) and (min-height: 1200px) {
        display: none;
    }
}

.v-icon.fa-square::before {
    color: #fef2f2;
}

.filter-checkbox {
    label {
        font-size: 1.1rem;
        color: #492363 !important;
        font-family: 'Fredoka One';
        font-weight: 400;
        margin: 0 0 0 10px;
    }
    .v-messages {
        display: none;
    }
}

.form-group--checkbox {
    margin-bottom: 20px;
}
</style>
